module.exports = __webpack_public_path__ + "static/img/img_logo.5f2daa76.png";